import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';
import './CookieBanner.css';

const STORAGE_KEY = 'vivify_cookie_consent';

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      // Small delay so it slides in after page load
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(STORAGE_KEY, 'rejected');
    setVisible(false);
  };

  const handleLearnMore = () => {
    navigate('/privacy-policy');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={`cookie-banner ${visible ? 'cookie-banner--visible' : ''}`} role="dialog" aria-label="Cookie consent" aria-live="polite">
      <div className="cookie-banner-inner">
        <div className="cookie-banner-icon">
          <Cookie size={20} />
        </div>

        <div className="cookie-banner-content">
          <p className="cookie-banner-title">We use cookies</p>
          <p className="cookie-banner-desc">
            We use cookies and similar technologies to improve your experience, analyse site traffic, and personalise content. By continuing, you agree to our use of cookies.
          </p>
        </div>

        <div className="cookie-banner-actions">
          <button
            id="cookie-learn-more"
            className="cookie-btn cookie-btn--ghost"
            onClick={handleLearnMore}
          >
            Learn More
          </button>
          <button
            id="cookie-reject"
            className="cookie-btn cookie-btn--outline"
            onClick={handleReject}
          >
            Reject Optional
          </button>
          <button
            id="cookie-accept"
            className="cookie-btn cookie-btn--primary"
            onClick={handleAccept}
          >
            Accept All
          </button>
        </div>

        <button
          className="cookie-close-btn"
          onClick={handleReject}
          aria-label="Close cookie banner"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
